import { createReducer, on } from '@ngrx/store';
import { initialUsersState, IUsersState } from './users.state';
import { LoggedUserLoaded, UsersLoaded, UsersForClientFilterLoaded } from './users.actions';

export const initialState: IUsersState = {
  users: [],
  usersForClientFilter: [],
  loggedUser: {}
};

const setUsers = (state: IUsersState, { users }: { users: [] }) => ({
  ...state,
  users: users?.map((user: any) => {
    const userInState = state.users?.find(u => u.id === user.id) || {};
    return { ...userInState, ...user };
  }) 
});

const setUsersForClientFilter = (state: IUsersState, { usersForClientFilter }: { usersForClientFilter: [] }) => ({
  ...state,
  usersForClientFilter: usersForClientFilter.map((user: any) => {
    const userInState = state.usersForClientFilter.find(u => u.id === user.id);
    return { ...userInState, ...user };
  })  
});


const setLoggedUser = (state: IUsersState, { loggedUser }: { loggedUser: any }) => ({
  ...state,
  loggedUser: loggedUser
});



const _UsersReducer = createReducer<IUsersState>(
  initialUsersState,
  on(UsersLoaded, setUsers),
  on(LoggedUserLoaded, setLoggedUser),
  on(UsersForClientFilterLoaded, setUsersForClientFilter)
);

export function usersReducer(state: IUsersState, action): IUsersState {
  return _UsersReducer(state, action);
}

export function usersForClientFilterReducer(state: IUsersState, action): IUsersState {
  return _UsersReducer(state, action);
}
